import { Grid2 } from "@mui/material";
import AttendanceSection from "Components/Leaderboard/AttendanceSection/AttendanceSection";
import LeaderBoardCards from "Components/Leaderboard/LeaderBoardCards";
import RankSection from "Components/Leaderboard/RankSection/RankSection";
import SkillSection from "Components/Leaderboard/SkillSection/SkillSection";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { getLeaderBoard } from "Slices/thunks";

const styles = (theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  "& .leaderBoardContent": {
    border: `1px solid ${theme.palette.border.blue}`,
    borderRadius: "8px",
    padding: "16px",
  },
});

const LeaderBoard = () => {
  let params = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    const courseId = localStorage.getItem("CourseID")
    dispatch(getLeaderBoard({CourseID: courseId}));

  }, [])

  return (
    <Grid2 sx={styles}>
      <LeaderBoardCards />
      <Grid2 className="leaderBoardContent">
        {!params?.tab || params?.tab == "rank" ? (
          <RankSection />
        ) : params?.tab == "skill" ? (
          <SkillSection />
        ) : params?.tab == "attendance" ? (
          <AttendanceSection />
        ) : (
          ""
        )}
      </Grid2>
    </Grid2>
  );
};

export default LeaderBoard;
